import { Platform } from 'react-native';
import { getThemeColors } from './themeState';

// Legacy-compatible dynamic access. Components that use useAppTheme receive the
// same palette reactively; these getters preserve existing non-hook consumers.
const _colors = {};
const colorKeys = [
  'primary', 'secondary', 'background', 'white', 'highlight', 'error', 'success',
  'surface', 'surfaceElevated', 'inputBackground', 'mutedSurface',
  'text', 'textSecondary', 'lightText', 'border', 'divider', 'lightBorder',
  'onPrimary', 'onSecondary', 'onError', 'overlay', 'shadow',
  'successSurface', 'primarySurface', 'dangerSurface', 'warning', 'warningSurface',
];
colorKeys.forEach(key => {
  Object.defineProperty(_colors, key, {
    get() { return getThemeColors()[key]; },
    enumerable: true,
  });
});

export const colors = _colors;

export const typography = {
  fontFamily: {
    regular: 'System',
    medium: 'System',
    bold: 'System',
  },
  fontSize: {
    small: 12,
    regular: 14,
    medium: 16,
    large: 18,
    xlarge: 20,
    xxlarge: 24,
  },
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const layout = {
  borderRadius: {
    small: 4,
    medium: 8,
    large: 12,
  },
  shadow: {
    small: Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
      },
      android: {
        elevation: 1,
      },
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 1,
      }
    }),
    medium: Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 2,
      }
    }),
    large: Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 4,
      }
    }),
  },
};
